var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankCards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 23H2.75C1.233 23 0 21.767 0 20.25V11.75C0 10.233 1.233 9 2.75 9H17.25C18.767 9 20 10.233 20 11.75V20.25C20 21.767 18.767 23 17.25 23ZM2.75 10.5C2.061 10.5 1.5 11.061 1.5 11.75V20.25C1.5 20.939 2.061 21.5 2.75 21.5H17.25C17.939 21.5 18.5 20.939 18.5 20.25V11.75C18.5 11.061 17.939 10.5 17.25 10.5H2.75Z",
    fill: "#A6AAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 17H4.75C3.785 17 3 16.215 3 15.25V13.75C3 12.785 3.785 12 4.75 12H6.25C7.215 12 8 12.785 8 13.75V15.25C8 16.215 7.215 17 6.25 17ZM4.75 13.5C4.612 13.5 4.5 13.612 4.5 13.75V15.25C4.5 15.388 4.612 15.5 4.75 15.5H6.25C6.388 15.5 6.5 15.388 6.5 15.25V13.75C6.5 13.612 6.388 13.5 6.25 13.5H4.75Z",
    fill: "#A6AAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 20.0001H3.75C3.336 20.0001 3 19.6641 3 19.2501C3 18.8361 3.336 18.5001 3.75 18.5001H16.25C16.664 18.5001 17 18.8361 17 19.2501C17 19.6641 16.664 20.0001 16.25 20.0001Z",
    fill: "#A6AAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.75 6.50012H5.25C4.836 6.50012 4.5 6.16412 4.5 5.75012C4.5 5.33612 4.836 5.00012 5.25 5.00012H22.75C23.164 5.00012 23.5 5.33612 23.5 5.75012C23.5 6.16412 23.164 6.50012 22.75 6.50012Z",
    fill: "#A6AAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.25 14.7199C21.989 14.7199 21.735 14.5829 21.597 14.3399C21.392 13.9799 21.519 13.5219 21.879 13.3179C22.267 13.0979 22.499 12.6979 22.499 12.2499V3.74988C22.499 3.06088 21.938 2.49988 21.249 2.49988H6.75C6.061 2.49988 5.5 3.06088 5.5 3.74988V6.74988C5.5 7.16388 5.164 7.49988 4.75 7.49988C4.336 7.49988 4 7.16388 4 6.74988V3.74988C4 2.23288 5.233 0.999878 6.75 0.999878H21.25C22.767 0.999878 24 2.23288 24 3.74988V12.2499C24 13.2309 23.471 14.1399 22.62 14.6229C22.503 14.6889 22.376 14.7199 22.25 14.7199Z",
    fill: "#A6AAB0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCards);
export default __webpack_public_path__ + "static/media/bank-cards.a8009e69.svg";
export { ForwardRef as ReactComponent };